import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CreditTabs = ({ selectedTab, onSelectTab, isReview }) => {
  const tabs = [{ name: "New", current: selectedTab === "New" }];
  if (isReview) {
    tabs.push(
      { name: "Closed", current: selectedTab === "Closed" }
    );
  }
  return (
    <div>
      <div className="block">
        <nav className="flex items-center gap-[1px]" aria-label="Tabs">
          {tabs.map((tab, tabIdx) => (
            <button
              key={tab.name}
              onClick={() => onSelectTab(tab.name)}
              className={classNames(
                tab.current
                  ? "bg-primary text-white"
                  : " bg-[#EBEFF3] text-[#485868]",
                tabIdx === 0 ? "rounded-tl-[10px] rounded-bl-[10px]" : "",
                tabIdx === tabs.length - 1
                  ? "rounded-tr-[10px] rounded-br-[10px]"
                  : "",
                "group overflow-hidden h-[46px] flex items-center justify-center text-center text-sm font-bold leading-[160%] px-3 min-w-[104px] sm:min-w-[71px]"
              )}
              aria-current={tab.current ? "page" : undefined}
            >
              <span>{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
export default CreditTabs;
